export default {
  viewBox: "0 0 25 24",
  paths: [
    "M9.13109 6.17334L10.1313 5.18994L16.6138 11.8611L10.1313 18.8101L9.13109 17.8391L14.7833 11.8611L9.13109 6.17334Z"
  ]
};